<template>
    <div>
        <div class="cloak" @click="$emit('close')"></div>
        <div class="hms-device-selector">
            <h3>Audio Input</h3>
            <ul>
                <li
                    v-for="device in devices.audioInput"
                    :key="device.deviceId"
                    :class="{ active: device.deviceId === audioInput }"
                    @click="
                        $emit('select', {
                            type: 'audioInput',
                            id: device.deviceId,
                        })
                    "
                >
                    {{ device.label }}
                </li>
            </ul>
            <h3>Audio Output</h3>
            <ul>
                <li
                    v-for="device in devices.audioOutput"
                    :key="device.deviceId"
                    :class="{ active: device.deviceId === audioOutput }"
                    @click="
                        $emit('select', {
                            type: 'audioOutput',
                            id: device.deviceId,
                        })
                    "
                >
                    {{ device.label }}
                </li>
            </ul>
            <h3>Video Input</h3>
            <ul>
                <li
                    v-for="device in devices.videoInput"
                    :key="device.deviceId"
                    :class="{ active: device.deviceId === videoInput }"
                    @click="
                        $emit('select', {
                            type: 'videoInput',
                            id: device.deviceId,
                        })
                    "
                >
                    {{ device.label }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { hmsStore } from "../hms";
import { selectDevices } from "@100mslive/hms-video-store";

export default {
    name: "HmsDeviceSelector",
    props: ["audioInput", "audioOutput", "videoInput"],
    data() {
        return {
            devices: {
                audioInput: [],
                audioOutput: [],
                videoInput: [],
            },
        };
    },
    mounted() {
        hmsStore.subscribe((devices) => {
            this.devices.audioInput = devices.audioInput;
            this.devices.audioOutput = devices.audioOutput;
            this.devices.videoInput = devices.videoInput;
        }, selectDevices);
    },
};
</script>

<style scoped>
.cloak {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    background: #0001;
}

.hms-device-selector {
    position: absolute;
    bottom: 50px;
    left: 0;
    z-index: 2001;
    background: #333;
    padding: 16px;
    border-radius: 4px;
    color: #fff;
    width: 30vw;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1);
}

h3 {
    font-size: 16px;
    margin-top: 8px;
}

ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 12px;
}

ul li {
    padding: 8px;
    border-radius: 4px;
}

ul li:hover {
    background: #555;
    cursor: pointer;
}

ul li.active {
    background: #38f;
}
</style>
